<template>
  <el-dialog
    :title="type === 'add' ? '新增': '编辑'"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1300px"
    v-dialogDrag
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      inline
      label-width="150px"
      size="small"
    >
      <el-form-item label="设备厂商" prop="manufacturer">
        <el-select class="w-199px" v-model="ruleForm.manufacturer" placeholder="请选择" @change="getProtocolList" :disabled="type==='edit'">
          <el-option
            v-for="item in facturerList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型归属" prop="deviceType">
        <el-select class="w-199px" v-model="ruleForm.deviceType" placeholder="请选择" @change="getProtocolList" :disabled="type==='edit'">
          <el-option
            v-for="item in deviceTypeList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="接入协议" prop="protocolTypeCode">
        <el-select class="w-199px" v-model="ruleForm.protocolTypeCode" placeholder="请选择" @change="getSystemTemplate" :disabled="type==='edit'">
          <el-option
            v-for="item in protocolList"
            :key="item.protocolCode"
            :label="item.protocolName"
            :value="item.protocolCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="接入模板名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入"
          class="!w-199px"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="description">
        <el-input
          type="textarea"
          v-model="ruleForm.description"
          class="!w-560px"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="flex items-center mb-15px ml-10px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">配置模板属性</span>
      <i class="el-icon-circle-plus-outline text-22px cursor-pointer font-bold ml-5px !text-$systemMainColor" @click="addRow"></i>
    </div>

    <div class="table-list max-h-300px overflow-auto">
      <div class="flex items-center mb-10px" v-for="(item, index) in tableData" :key="index">
        <div class="ml-20px">
          <span>名称(key) </span>
          <el-input
            v-model="item.fieldName"
            placeholder="请输入"
            class="!w-150px"
            :disabled="item.isSystem"
          ></el-input>
        </div>
        <div class="ml-20px">
          <span>描述 </span>
          <el-input
            v-model="item.fieldTitle"
            placeholder="请输入"
            class="!w-150px"
            :disabled="item.isSystem"
          ></el-input>
        </div>
        <div class="ml-20px">
          <span>数据类型 </span>
          <el-select v-model="item.fieldType" placeholder="请选择" class="!w-120px" :disabled="item.isSystem">
            <el-option
              v-for="item in templateFieldTypeList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </div>
        <div class="ml-20px">
          <span>映射配置 </span>
          <el-input
            v-model="item.apiMapper"
            placeholder="请输入"
            class="!w-150px"
            :disabled="item.isSystem"
          ></el-input>
        </div>
        <div class="ml-20px">
          <span>必填 </span>
          <el-radio-group v-model="item.required" :disabled="item.isSystem">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
        <div class="ml-20px">
          <span>列表展示 </span>
          <el-radio-group v-model="item.showList" :disabled="item.isSystem">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
        <div class="ml-20px" v-if="!item.isSystem && index > 0">
          <i class="el-icon-remove-outline text-22px !text-$tagDangerText cursor-pointer font-bold" @click="delRow(index, item)"></i>
        </div>
      </div>
    </div>


    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="confirm" :loading="saveLoading">保存</el-button>
      <el-button @click="dialogShow = false" size="small">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { IOTDeviceTemplateApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
  },
  data() {
    return {
      ruleForm: {
        manufacturer: '',
        protocolTypeCode: '',
        name: '',
        deviceType: '',
        description: '',
      },
      rules: {
        manufacturer: [{ required: true, message: '请选择', trigger: 'change' }],
        protocolTypeCode: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        deviceType: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      facturerList: [],
      deviceTypeList: [],
      templateFieldTypeList: [],
      protocolList: [],
      saveLoading: false,
      speedList: [],
      tableData: [
        { fieldName: '', fieldTitle: '', fieldType: '', apiMapper: '', required: true, showList: false, id: null }
      ],
      deleteFieldIds: []
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    checkTable() {
      let flag = true
      for (let i = 0; i < this.tableData.length; i += 1) {
        const item = this.tableData[i]
        if (!item.fieldName) {
          flag = false
          this.$message.error('配置模板名称不能为空')
          return false
        }
        if (!item.fieldTitle) {
          flag = false
          this.$message.error('配置模板描述不能为空')
          return false
        }
        if (!item.fieldType) {
          flag = false
          this.$message.error('配置模板数据类型不能为空')
          return false
        }
        if (!item.apiMapper) {
          flag = false
          this.$message.error('配置模板映射配置不能为空')
          return false
        }
      }
      return flag
    },
    confirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (!this.checkTable()) return
          this.saveLoading = true
          const [err] = this.type === 'add' ?
            await ioTdeviceManagementApi.create({
              body: {
                ...this.ruleForm,
                fields: this.tableData
              }
            }) :
            await ioTdeviceManagementApi.update(this.detailRow.id, {
              body: {
                ...this.ruleForm,
                fields: this.tableData,
                deleteFieldIds: this.deleteFieldIds
              }
            })
          if (!err) {
            this.$emit('reload')
            this.$message.success(this.type === 'add' ? '新增成功' : '编辑成功')
            this.dialogShow = false
          }
          this.saveLoading = false
        }
      })
    },
    addRow() {
      let fieldType = ''
      if (this.templateFieldTypeList.length) {
        fieldType = this.templateFieldTypeList[0].code
      }
      this.tableData.push({ fieldName: '', fieldTitle: '', fieldType, apiMapper: '', required: true, showList: false, isSystem: false })
    },
    delRow(index, row) {
      this.tableData.splice(index, 1)
      if (row.id) {
        this.deleteFieldIds.push(row.id)
      }
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType', 'IOTDeviceTemplateFieldType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        let templateFieldTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') { // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') { // 类型归属
            deviceTypeList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateFieldType') { // 数据类型
            templateFieldTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.templateFieldTypeList = templateFieldTypeList
      }
    },
    // 获取协议列表
    async getProtocolList() {
      this.ruleForm.protocolTypeCode = ''
      if (!this.ruleForm.manufacturer || !this.ruleForm.deviceType) {
        return
      }
      const [err, res] = await ioTdeviceManagementApi.getProtocolList({
        manufacturerCode: this.ruleForm.manufacturer,
        deviceTypeCode: this.ruleForm.deviceType,
        skipCount: 0,
        maxResultCount: 99,
      })
      if (!err) {
        this.protocolList = res.items
      } else {
        this.protocolList = []
      }
    },
    // 获取系统模板
    async getSystemTemplate() {
      const [err, res] = await ioTdeviceManagementApi.getIOTDeviceTemplateFieldsSystem({
        manufacturerCode: this.ruleForm.manufacturer,
        protocolTypeCode: this.ruleForm.protocolTypeCode,
        deviceTypeCode: this.ruleForm.deviceType
      })
      if (!err) {
        this.tableData = res
      }
    },
    // 获取详情
    async getDetail() {
      const [err, res] = await ioTdeviceManagementApi.get(this.detailRow.id)
      if (!err) {
        const { templateFields, ...result } = res
        this.ruleForm = result
        this.tableData = templateFields
        const [protocolErr, protocolRes] = await ioTdeviceManagementApi.getProtocolList({
          manufacturerCode: this.ruleForm.manufacturer,
          deviceTypeCode: this.ruleForm.deviceType,
          SkipCount: 0,
          MaxResultCount: 99,
        })
        if (!protocolErr) {
          this.protocolList = protocolRes.items
        } else {
          this.protocolList = []
        }
      }
    }
  },
  created() {
    this.getCategoryByCodes()
    if (this.type === 'edit') {
      this.getDetail()
    }
  }
}
</script>
